<template>
  <v-menu
    max-width="205"
    open-on-click
    offset-y
    top
    left
    tile
    z-index="4"
    content-class="tray-products__menu elevation-3"
  >
    <template #activator="{ on, attrs }">
      <div class="d-flex pointer ml-auto" v-bind="attrs" v-on="on">
        <icons-settings-line />
      </div>
    </template>

    <v-list dense>
      <v-list-item dense @click="$emit('onGiftOptions')">
        <v-list-item-icon class="d-flex align-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.54788 19.3265H17.3073V8.57464H6.54788V19.3265ZM18.0531 20.7745H5.84596C5.45054 20.7745 5.14285 20.467 5.14285 20.0725V7.87198C5.14285 7.47741 5.45054 7.16992 5.84596 7.16992H18.0092C18.4052 7.16992 18.7123 7.47741 18.7123 7.87198V20.0286C18.7562 20.4232 18.4491 20.7745 18.0531 20.7745Z" fill="#62646A"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9941 20.5983C11.5981 20.5983 11.2904 20.2902 11.2904 19.8956V8.17862C11.2904 7.78346 11.5981 7.47656 11.9941 7.47656C12.3889 7.47656 12.696 7.78346 12.696 8.17862V19.8956C12.696 20.247 12.3889 20.5983 11.9941 20.5983Z" fill="#62646A"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.0093 12.0403H6.1087C5.71387 12.0403 5.40619 11.7334 5.40619 11.3382C5.40619 10.943 5.71387 10.6367 6.1087 10.6367H18.0093C18.4054 10.6367 18.7124 10.943 18.7124 11.3382C18.7124 11.7334 18.4054 12.0403 18.0093 12.0403Z" fill="#62646A"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.1689 8.52872C11.9941 8.52872 11.8619 8.48488 11.7302 8.35335L8.34869 5.58835C8.04101 5.3253 7.99714 4.88629 8.26095 4.5794C8.52417 4.27132 8.96346 4.22807 9.27055 4.49172L12.6521 7.25612C12.9598 7.51976 13.0037 7.95818 12.7398 8.26626C12.6076 8.44104 12.3889 8.52872 12.1689 8.52872Z" fill="#62646A"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7741 8.52872C11.5542 8.52872 11.3787 8.44104 11.2471 8.26626C10.9833 7.95818 11.0271 7.51976 11.3348 7.25612L14.7164 4.49172C15.0229 4.22807 15.4633 4.27132 15.726 4.5794C15.9898 4.88629 15.9459 5.3253 15.6382 5.58835L12.2128 8.35335C12.0812 8.48488 11.9502 8.52872 11.7741 8.52872Z" fill="#62646A"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9501 8.44172C11.5541 8.44172 11.247 8.13483 11.247 7.73966V3.70206C11.247 3.30749 11.5541 3 11.9501 3C12.3449 3 12.652 3.30749 12.652 3.70206V7.73966C12.652 8.09098 12.3449 8.44172 11.9501 8.44172Z" fill="#62646A"/>
          </svg>
        </v-list-item-icon>
        <v-list-item-title>
          {{ giftOptions }} {{ giftOptions === 1 ? 'Gift option' : 'Gifts options'}}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="showCampaignSettings && !userIsInGeneralGroup"
        dense
        @click="$emit('onCampaignSettings')"
      >
        <v-list-item-icon class="d-flex align-center">
          <icons-sidebar-sub-account :width="24" :height="20" color="#62646A" />
        </v-list-item-icon>
        <v-list-item-title class="d-flex g10 align-center">
          Assign users
        </v-list-item-title>
      </v-list-item>

      <v-list-item dense @click="$emit('onEstimateCost')">
        <v-list-item-icon class="d-flex align-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.15386 17.8461H9.34616V15.8461H11.3462V14.6538H9.34616V12.6538H8.15386V14.6538H6.15386V15.8461H8.15386V17.8461ZM13.1539 17.0961H17.8462V15.9038H13.1539V17.0961ZM13.1539 14.5961H17.8462V13.4038H13.1539V14.5961ZM14.1 10.7192L15.5 9.3192L16.9 10.7192L17.7385 9.88075L16.3385 8.44998L17.7385 7.04998L16.9 6.21153L15.5 7.61153L14.1 6.21153L13.2616 7.04998L14.6616 8.44998L13.2616 9.88075L14.1 10.7192ZM6.40386 9.04613H11.0962V7.85383H6.40386V9.04613ZM5.30773 20.5C4.8026 20.5 4.37503 20.325 4.02503 19.975C3.67503 19.625 3.50003 19.1974 3.50003 18.6923V5.3077C3.50003 4.80257 3.67503 4.375 4.02503 4.025C4.37503 3.675 4.8026 3.5 5.30773 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80257 20.5 5.3077V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30773ZM5.30773 19H18.6923C18.7692 19 18.8397 18.9679 18.9039 18.9038C18.968 18.8397 19 18.7692 19 18.6923V5.3077C19 5.23077 18.968 5.16024 18.9039 5.09613C18.8397 5.03203 18.7692 4.99998 18.6923 4.99998H5.30773C5.2308 4.99998 5.16027 5.03203 5.09616 5.09613C5.03206 5.16024 5.00001 5.23077 5.00001 5.3077V18.6923C5.00001 18.7692 5.03206 18.8397 5.09616 18.9038C5.16027 18.9679 5.2308 19 5.30773 19Z" fill="#62646A"/>
          </svg>
        </v-list-item-icon>
        <v-list-item-title class="d-flex g10 align-center">
          Estimate cost

          <common-tooltip top :max-width="250">
            {{ getTooltipTextBySlug('campaign_card_estimate_cost') }}
          </common-tooltip>
        </v-list-item-title>
      </v-list-item>

      <v-list-item dense @click="$emit('onPreview')">
        <v-list-item-icon class="d-flex align-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.5354 11.3438L6.41784 4.13109C6.2764 4.0469 6.11518 4.00169 5.95058 4.00005C5.78599 3.99841 5.62389 4.0404 5.4808 4.12175C5.3377 4.2031 5.21872 4.32091 5.13594 4.46319C5.05316 4.60546 5.00955 4.76713 5.00955 4.93173V19.0687C5.00974 19.2318 5.05273 19.392 5.13422 19.5334C5.21571 19.6747 5.33284 19.7921 5.47393 19.874C5.61502 19.9559 5.77513 19.9993 5.93825 20C6.10138 20.0006 6.26182 19.9585 6.40356 19.8777L18.521 12.9536C18.6624 12.8728 18.7802 12.7563 18.8625 12.6158C18.9449 12.4753 18.989 12.3157 18.9904 12.1529C18.9919 11.99 18.9506 11.8296 18.8707 11.6877C18.7909 11.5458 18.6752 11.4272 18.5353 11.344L18.5354 11.3438ZM6.25188 18.5335V5.47804L17.4423 12.139L6.25188 18.5335Z" fill="#62646A"/>
          </svg>
        </v-list-item-icon>
        <v-list-item-title>
          Preview eGift
        </v-list-item-title>
      </v-list-item>

      <v-list-item v-if="showEditCampaign" dense @click="$emit('onEdit')">
        <v-list-item-icon class="d-flex align-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.647 14.7879L8.97124 17.1125L5.5 18.28L6.647 14.7879ZM7.58483 13.9436L13.9853 7.54313L16.2164 9.7739L9.8156 16.1743L7.58483 13.9436ZM14.8817 6.64666L15.8616 5.63551C15.9662 5.54517 16.0809 5.5 16.2056 5.5C16.3307 5.5 16.4454 5.54517 16.5499 5.63551L18.1445 7.23041C18.2348 7.3277 18.2803 7.4441 18.2803 7.57962C18.2803 7.71513 18.2348 7.82841 18.1445 7.9184L17.1125 8.87742L14.8817 6.64666Z" fill="#62646A"/>
          </svg>
        </v-list-item-icon>
        <v-list-item-title>
          Edit campaign
        </v-list-item-title>
      </v-list-item>

      <v-list-item v-if="showEditCampaign" dense @click="$emit('onDuplicate')">
        <v-list-item-icon class="d-flex align-center justify-center" style="width: 24px">
          <icons-copy :width="18" :height="18" color="#62646A" />
        </v-list-item-icon>
        <v-list-item-title>
          Duplicate campaign
        </v-list-item-title>
      </v-list-item>

      <v-list-item v-if="masterAccount || superAdmin" dense @click="$emit('onAddAutomation')">
        <v-list-item-icon class="d-flex align-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.50003 20.5V15.9787C4.50003 15.4813 4.67704 15.0561 5.03106 14.7029C5.38506 14.3497 5.81061 14.1731 6.30773 14.1731H17.6923C18.1894 14.1731 18.615 14.3501 18.969 14.7041C19.323 15.0581 19.5 15.4836 19.5 15.9808V20.5H4.50003ZM9.14426 12.7884C7.85935 12.7884 6.7641 12.3356 5.85848 11.43C4.95285 10.5244 4.50003 9.42911 4.50003 8.14423C4.50003 6.85933 4.95285 5.76407 5.85848 4.85845C6.7641 3.95282 7.85935 3.5 9.14426 3.5H14.8558C16.1407 3.5 17.2359 3.95282 18.1415 4.85845C19.0472 5.76407 19.5 6.85933 19.5 8.14423C19.5 9.42911 19.0472 10.5244 18.1415 11.43C17.2359 12.3356 16.1407 12.7884 14.8558 12.7884H9.14426ZM6.00001 19H18V15.9808C18 15.891 17.9712 15.8173 17.9135 15.7596C17.8558 15.7019 17.782 15.673 17.6923 15.673H6.30773C6.21798 15.673 6.14426 15.7019 6.08656 15.7596C6.02886 15.8173 6.00001 15.891 6.00001 15.9808V19ZM9.14426 11.2885H14.8558C15.734 11.2885 16.4776 10.984 17.0865 10.375C17.6955 9.76602 18 9.02243 18 8.14423C18 7.26601 17.6955 6.52242 17.0865 5.91345C16.4776 5.30447 15.734 4.99998 14.8558 4.99998H9.14426C8.26604 4.99998 7.52245 5.30447 6.91348 5.91345C6.3045 6.52242 6.00001 7.26601 6.00001 8.14423C6.00001 9.02243 6.3045 9.76602 6.91348 10.375C7.52245 10.984 8.26604 11.2885 9.14426 11.2885ZM9.14391 9.0096C9.38901 9.0096 9.59456 8.9267 9.76058 8.7609C9.92661 8.5951 10.0096 8.38965 10.0096 8.14455C10.0096 7.89947 9.92673 7.69391 9.76093 7.52788C9.59513 7.36186 9.38968 7.27885 9.14458 7.27885C8.8995 7.27885 8.69394 7.36175 8.52791 7.52755C8.36189 7.69335 8.27888 7.89879 8.27888 8.14388C8.27888 8.38898 8.36178 8.59453 8.52758 8.76055C8.69338 8.92658 8.89882 9.0096 9.14391 9.0096ZM14.8554 9.0096C15.1005 9.0096 15.3061 8.9267 15.4721 8.7609C15.6381 8.5951 15.7211 8.38965 15.7211 8.14455C15.7211 7.89947 15.6382 7.69391 15.4724 7.52788C15.3066 7.36186 15.1012 7.27885 14.8561 7.27885C14.611 7.27885 14.4054 7.36175 14.2394 7.52755C14.0734 7.69335 13.9904 7.89879 13.9904 8.14388C13.9904 8.38898 14.0733 8.59453 14.2391 8.76055C14.4049 8.92658 14.6103 9.0096 14.8554 9.0096Z" fill="#62646A"/>
          </svg>
        </v-list-item-icon>
        <v-list-item-title>
          {{ isAutomated ? 'Edit' : 'Add' }} automation
        </v-list-item-title>
      </v-list-item>

      <v-list-item dense @click="$emit('on-view-analytics')">
        <v-list-item-icon class="d-flex align-center">
          <icons-analytics />
        </v-list-item-icon>
        <v-list-item-title class="d-flex g10 align-center">
          View analytics
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import userIsCgElite from '@/mixins/userIsCgElite'
import superAdmin from '@/mixins/superAdmin'
import masterAccount from '@/mixins/masterAccount'
import getTooltipTextBySlug from '@/mixins/getTooltipTextBySlug'

export default {
  name: 'TheCampaignCardSettings',
  mixins: [
    superAdmin,
    masterAccount,
    userIsCgElite,
    getTooltipTextBySlug,
  ],
  props: {
    giftOptions: {
      type: Number,
      required: true
    },
    isAutomated: {
      type: Boolean,
      required: false,
      default: false,
    },
    // page level permissions
    userPermissions: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    // campaign level permissions
    campaignPermissions: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },
  computed: {
    userIsAnAdmin () {
      return this.$store.state.header?.headerData?.isAdmin || false
    },
    showCampaignSettings () {
      return this.userPermissions.includes('assign_accounts')
    },
    showEditCampaign () {
      return this.campaignPermissions.includes('update')
    },
    userIsInGeneralGroup () {
      const companyId = this.$store.state.header?.headerData?.companyId ?? 1;
      return companyId === 1
    },
  }
}
</script>

<style lang="scss">
.tray-products__menu {
  padding: 0px !important;

  .v-list {
    padding: 8px 0px;
  }

  .v-list-item {
    padding: 0px 16px !important;
    cursor: pointer;

    &:not(&--disabled) {
      color: #62646A !important;
    }

    &--disabled {
      color: #D3D2D2 !important;
      pointer-events: auto;
    }

    &--dense {
      min-height: 30px;
    }

    &__icon {
      margin: 3px 12px 3px 0px !important;
    }

    &__title {
      font-family: 'Lato-Regular', sans-serif !important;
      font-size: 14px !important;
      letter-spacing: 0 !important;
      line-height: 30px !important;
      color: inherit !important;
    }
  }
}
</style>
